
export default {
  props: {
    isShop: {
      type: Boolean,
      default: false
    }
  }
}
